export default "__VITE_ASSET__B7rRWJ1$__"